import { BUILD_ENVIRONMENT_NAMES } from '@/env-config';

import { launchMissingProductConnectorDialog } from '../components/MissingProductConnectorDialog';
import { launchUpsellDialog } from '../components/ProductUpsellDialogs';
import { ConnectorIds, PRODUCT_CONNECTOR_MAP } from '../constants';
import { IPlatformRole } from '../dto/auth/UserInfo/Interface';
import { toQueryParams } from './query-helpers';
import { checkIfUserHasTheApp } from './user-app-relation-helpers';

const BUILD_ENV = process.env.COPILOT_BUILD_ENV;

export function connectApp(
  connectorId: ConnectorIds,
  platformRoles: IPlatformRole[],
  redirectPath: string = ''
) {
  if (
    connectorId in PRODUCT_CONNECTOR_MAP &&
    !(BUILD_ENV === BUILD_ENVIRONMENT_NAMES.TESTING && connectorId === ConnectorIds.Sign)
  ) {
    const userHasProductAccess = checkIfUserHasTheApp(connectorId, platformRoles);

    if (!userHasProductAccess) {
      if (connectorId === ConnectorIds.Documents) {
        launchUpsellDialog(connectorId);
      } else {
        launchMissingProductConnectorDialog();
      }

      return;
    }
  }

  const queryParams = toQueryParams({
    redirectPath: redirectPath || window.location.pathname,
  });

  window.location.href = `/connector/${connectorId}${queryParams}`;
}
